export var AppHosting;
(function (AppHosting) {
    AppHosting[AppHosting["Frame"] = 0] = "Frame";
    AppHosting[AppHosting["Tab"] = 1] = "Tab";
})(AppHosting || (AppHosting = {}));
//# sourceMappingURL=app-hosting.js.map